export enum CustomerValidationStatus {
  ALL = 'ALL',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  TIMEOUT = 'TIMEOUT',
}
